import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import HowToRegister from './components/HowToRegister';
import CategoryPreview from './components/CategoryPreview';
import SecuritySection from './components/SecuritySection';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { homeSchemas } from '@/mocks/schema/home';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <title>2pg·com登录注册 - 快速开户立即畅玩 | 2pg平台官网</title>
      <meta
        name="description"
        content="2pg·com 登录注册流程简单快捷，支持手机/邮箱一键注册，老用户秒速登录，安全加密保障账户安全。立即完成2pg·com注册，享受专属新人福利与平台全部功能，随时随地畅享优质体验。"
      />
      <meta
        name="keywords"
        content="2pg·com登录注册,2pg登录,2pg注册,2pg·com官网,2pg账号注册,2pg平台登录,2pg开户"
      />
      <link rel="canonical" href="https://2pg.com/" />
      <SchemaOrg schemas={homeSchemas} />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturesSection />
        <HowToRegister />
        <CategoryPreview />
        <SecuritySection />
        <ArticlePreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}